import {FieldType} from "./field-type"
import FieldsFactory from "./fields-factory"
import CUSTOM_FIELDS_V1 from "../gd/const/fields/custom-fields-v1"
import FieldProto from "./proto/field-proto"
import {FieldParams} from "./proto/types"

const fieldTypesMap = {
    [CUSTOM_FIELDS_V1.type.NUMBER]          : FieldType.NUMBER,
    [CUSTOM_FIELDS_V1.type.STRING]          : FieldType.STRING,
    [CUSTOM_FIELDS_V1.type.DATE]            : FieldType.DATE,
    [CUSTOM_FIELDS_V1.type.CURRENCY]        : FieldType.CURRENCY,
    [CUSTOM_FIELDS_V1.type.PERCENTAGE]      : FieldType.PERCENTAGE,
    [CUSTOM_FIELDS_V1.type.BOOLEAN]         : FieldType.CHECKBOX,
    [CUSTOM_FIELDS_V1.type.LIST]            : FieldType.DROPDOWN,
    [CUSTOM_FIELDS_V1.type.LIST_MULTI]      : FieldType.MULTISELECT,
    [CUSTOM_FIELDS_V1.type.RATING]          : FieldType.RATING,
    [CUSTOM_FIELDS_V1.type.EMAIL]           : FieldType.EMAIL,
    [CUSTOM_FIELDS_V1.type.PHONE]           : FieldType.PHONE,
    [CUSTOM_FIELDS_V1.type.URL]             : FieldType.URL,
    [CUSTOM_FIELDS_V1.type.USER]            : FieldType.USER,
    [CUSTOM_FIELDS_V1.type.TEXT]            : FieldType.TEXT,
    [CUSTOM_FIELDS_V1.type.RAG]             : FieldType.RAG,
    [CUSTOM_FIELDS_V1.type.FORMULA]         : FieldType.FORMULA,
    [CUSTOM_FIELDS_V1.type.USERS]           : FieldType.USERS,
    [CUSTOM_FIELDS_V1.type.COLOR]           : FieldType.COLOR,


    [CUSTOM_FIELDS_V1.type.REACTION]        : FieldType.REACTION,
    [CUSTOM_FIELDS_V1.type.VOTING]          : FieldType.VOTING,
    [CUSTOM_FIELDS_V1.type.ATTACHMENT]      : FieldType.ATTACHMENT,
    [CUSTOM_FIELDS_V1.type.TIME_OF_DAY]     : FieldType.TIME_OF_DAY,
    [CUSTOM_FIELDS_V1.type.DATE_AND_TIME]   : FieldType.DATE_AND_TIME,
    [CUSTOM_FIELDS_V1.type.TOGGLE]          : FieldType.TOGGLE,
    [CUSTOM_FIELDS_V1.type.ADDRESS]         : FieldType.ADDRESS,
    [CUSTOM_FIELDS_V1.type.DEPARTMENT]      : FieldType.DEPARTMENT,
    [CUSTOM_FIELDS_V1.type.SKILLS]          : FieldType.SKILLS,
    [CUSTOM_FIELDS_V1.type.INTERNAL_DB]     : FieldType.INTERNAL_DB,
}

// const debug = "Field1ToField2Converter"
const debug = false

// !!!! this is CUSTOM FIELD converter !!!!

export default class Field1ToField2Converter {

    static convert(customField1Id:string): FieldProto | undefined {
        const field2Config = Field1ToField2Converter.getField2Config(customField1Id)

        if (field2Config) {
            return FieldsFactory.get(field2Config)
        }

        console.error("#ERROR-CONVERT-1 Error converting field ", customField1Id)
        return undefined
    }

    static getField2Config = (customFieldId:string) => {

        const customField = gd.session.customFields.get(customFieldId)

        if (!customField) {
            debug && console.log(debug, "#9037373 not custom field by ID=", customFieldId, " found")
            return null
        }

        const field3Type:FieldType = fieldTypesMap[customField.type]
        if (!field3Type) {
            debug && console.log(debug, "#kkdjd903283 no FieldType found!!! custmFieldType=", customField.type)
            return null
        }

        const convertItemsToOptions = (items:any) => _.map(items, item=>({
            value: item.id,
            label: item.value,
            color: item.color
        }))

        return {
            fieldId             : customFieldId,
            type                : field3Type,

            label               : customField.displayName,
            fieldAccess         : customField.access,
            isCustom            : true,

            decimalPlaces       : customField.params.decimalPlaces,                     //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE, FieldType.FORMULA
            positiveOnly        : customField.params.positiveOnly,                      //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE
            integersOnly        : customField.params.integersOnly,                      //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE
            symbolId            : customField.params.symbol,                            //  FieldType.CURRENCY, FieldType.FORMULA
            options             : convertItemsToOptions(customField.params.listItems),  //  FieldType.DROPDOWN, FieldType.MULTISELECT

            // if true, then 'Edit options' is shown in popover and it opens new edit field modal
            // which is different from old custom field edit modal
            // but is still used to edit from List/Table/Gantt header and has scope options.
            // New edit field modal has 'Is required' option which is meaningless in List/Table/Gantt
            // showMenuMore    : false,                                                //  FieldType.DROPDOWN, FieldType.MULTISELECT
            showMenuMore        : true,                                                //  FieldType.DROPDOWN, FieldType.MULTISELECT

            scale               : customField.params.ratingType,                        //  FieldType.RATING

            formula             : customField.params.formula,                           //  FieldType.FORMULA
            formatType          : customField.params.formatType,                        //  FieldType.FORMULA

            fieldParams         : customField.params as FieldParams                                  // all custom fields (is added for FieldType.INTERNAL_DB)
        };
    }
}
